export default __webpack_public_path__ + "static/media/keenpoint-logo-horizontal-branca.c7795992.png";